import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'hm-icon-sticker',
  templateUrl: './icon-sticker.component.html',
  styleUrls: ['./icon-sticker.component.scss'],
})
export class IconStickerComponent {}
